import { OrderStatus } from './index';

/**
 * Model to hold OrderItem details for an Order
 */
export class OrderTransactionItem {
    public id: string;
    public orderItemId: string;
    public productTypeId: string;
    public name: string;
    public quantity: number;
    public onlinePrice: number;
    public onsitePrice: number;
    public status: string;
    public paymentOptionType: string;
    public entityGuid: string;
    public entityName: string;
    public isEntityDeleted: boolean;
    public subtotal: string;
    public parentId: string;
    public children: OrderTransactionItem[] = [];
    public onlineSubtotal: number;
    public onsiteSubtotal: number;
    public onlineAmountPaid: number;

    get isPaid(): boolean {
        return this.status === OrderStatus.PAID;
    }

    get isUnpaid(): boolean {
        return this.status === OrderStatus.UNPAID;
    }

    get isPayOnsite(): boolean {
        return this.status === OrderStatus.PAY_ON_SITE;
    }

    get isInvalid(): boolean {
        return this.status === OrderStatus.INVALID;
    }

    get isRefunded(): boolean {
        return this.status === OrderStatus.REFUNDED;
    }

    get isNA(): boolean {
        return this.status === OrderStatus.NA;
    }

    get canRefund(): boolean {
        return this.isPaid;
    }

    get price(): number {
        if (this.isPayOnsite) {
            return this.onsitePrice;
        }

        return this.onlinePrice;
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): OrderTransactionItem {
        const data: any = json.data || json;
        const attrs: any = data.attributes;

        this.id = data.id;
        this.name = attrs.name;
        this.orderItemId = attrs.orderItemId;
        this.productTypeId = attrs.productTypeId;
        this.quantity = parseInt(attrs.quantity, null);
        this.onlinePrice = parseFloat(attrs.onlinePrice);
        this.onsitePrice = parseFloat(attrs.onsitePrice);
        this.onlineSubtotal = parseFloat(attrs.onlineSubtotal);
        this.onsiteSubtotal = parseFloat(attrs.onsiteSubtotal);
        this.onlineAmountPaid = parseFloat(attrs.onlineAmountPaid);
        this.status = attrs.status;
        this.paymentOptionType = attrs.paymentOptionType;
        this.entityGuid = attrs.entityGuid;
        this.entityName = attrs.entityName;
        this.subtotal = attrs.subtotal;
        this.parentId = attrs.parentId;
        this.isEntityDeleted = attrs.isEntityDeleted;

        return this;
    }
}
